import { render, staticRenderFns } from "./QrCodeSendResultDialog.vue?vue&type=template&id=10dd20fc&"
import script from "./QrCodeSendResultDialog.vue?vue&type=script&lang=js&"
export * from "./QrCodeSendResultDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports